import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { getAllInspectionRoadRoute } from '../../features/admin3/admin3Slice';
import AdminKarayollariKonumContainer from '../adminContainers/AdminKarayollariKonumContainer';
import Pagination from '../shared/Pagination';
import InputText from '../shared/input/new/InputText';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  .input-container{
    display: flex;
  }
    .btn-container{
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
    .titles {
        width: 100%;
        display: grid;
        grid-template-columns:repeat(5, 1fr);
        gap: 15px;
        padding-inline: 10px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);
        text-align: center;
        color: ${({ theme }) => theme.mainTextColor};
      }
`

const titles = ["Ekleme Tarihi", "İsim", "Başlangıç", "Bitiş", "Konumlar"];

const InspectionRoadRoute = () => {
    const {adminInspectionRoadRouteList, adminInspectionRoadRouteListCount} = useSelector((state) => state.admin3);
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(1);
    const [name, setName] = useState("");

    const itemsPerPage = 10;

    const totalPages = Math.ceil(adminInspectionRoadRouteListCount / itemsPerPage);

    useEffect(() => {
        dispatch(getAllInspectionRoadRoute({page: currentPage, name: name}))
      }, [currentPage, name])

    return (
        <Container>

            <div className="input-container">
              <InputText data={name}  setData={(e) => setName(e.target.value)} labelText="İsim" name={"name"} inputWidth={"200px"} />
            </div>

            <div className="titles">
                {titles.map((item) => (
                <p>{item}</p>
                ))}
            </div>

            {adminInspectionRoadRouteList.map((item) => (
                <AdminKarayollariKonumContainer data={item} />
            ))}


        {(adminInspectionRoadRouteList && adminInspectionRoadRouteList?.length > 0) && (
          <Pagination
            totalPages={totalPages}
            handleClick={setCurrentPage}
            currentPage={currentPage}
          />
        )}
        </Container>
    )
}

export default InspectionRoadRoute